<template lang="pug">
  .root
    the-heading(:breadcrumbs="breadcrumbs" :caption="'Результаты анализа данных пациента №' + values.id")
    .container
      .main_block
        .caption
          .globalCaptionStyles(style="margin-top: 100px") Результаты анализа данных пациента №{{values.id}}

        RequestTabs(:values="values" v-if="this.values !== false")

        .buttons
          button.more_btn(@click="toggleData = !toggleData; toggleGrade = false; docAndDiag = false")
            span(v-if="!toggleData") Показать исходные данные
            span(v-if="toggleData") Скрыть исходные данные
          button.more_btn(@click="docAndDiag = !docAndDiag; toggleGrade = false; toggleData = false")
            span(v-if="!docAndDiag") Показать исходные документы и диагнозы
            span(v-if="docAndDiag") Скрыть исходные документы и диагнозы
          button.grade_btn(@click="toggleGrade = !toggleGrade; toggleData = false; docAndDiag = false")
            v-icon(name="star")
        transition(name="fade")
          .dataBlock(v-if="toggleData")
            RequestSourseData(:values="values")
          .dataBlock(v-if="docAndDiag")
            RequestDocumentsAndDiagnosis(:values="values" prevState="RequestSummary")
          .GradeBlock(v-if="toggleGrade")
            .data_header Оценка работы системы пользователем
              .grade_block(v-if="values.result_correctness")
                .grade_header Общее впечатление о сервисе
                .grade_text {{values.result_correctness}}
                .grade_header Оценка предложенных рекомендаций
                .grade_text {{values.recommendation_correctness}}
                .grade_header Комментарий
                .grade_text {{values.wishes_correctness}}
              .grade_block(v-if="!values.result_correctness")
                .grade_text(style="margin-top: -20px; font-size: 17px")  Система не была оценена

        .disclaimer Данные «Webiomed» и любая информация, предоставленная в отношении программного продукта, предназначены только для информационных целей и не должны быть использованы для замены профессиональных медицинских консультаций. Окончательная постановка диагноза, назначение лечения и профилактических осмотров осуществляются врачом.
    the-footing
</template>
<script>
import axios from 'axios'
import Icon from 'vue-awesome/components/Icon'
import MeasureRadioButton from '../fields/MeasureRadioButton'
import TheHeading from '@/components/parts/TheHeading'
import TheFooting from '@/components/parts/TheFooting'
import breadcrumbs from '@/data/breadcrumbs/RequestSummary'

export default {
  components: {
    MeasureRadioButton,
    'v-icon': Icon,
    TheHeading,
    TheFooting,
    breadcrumbs,
    RequestSourseData: () => import('@//components/parts/RequestSourseData'),
    RequestDocumentsAndDiagnosis: () =>
      import('@//components/parts/RequestDocumentsAndDiagnosis'),
    RequestTabs: () => import('@//components/parts/RequestTabs')
  },
  data () {
    axios.get('dhra/api/v1/system/about/').then(result => {
      this.isProd = result.data.prod
    })
    return {
      breadcrumbs,
      toggleData: false,
      toggleGrade: false,
      docAndDiag: false,
      values: false,
      isProd: false
    }
  },
  methods: {
    setData (response) {
      this.values = response
    },
    editForm () {
      this.$store
        .dispatch('setForm', this.values)
        .then(() => {
          this.$router.push({
            name: 'Analysis',
            query: { savedForm: this.values.id }
          })
        })
        .catch(error => {
          console.error('error')
        })
    },

    showNewDesign () {
      window.open(`/newdesign/#/dhra/requests/${this.values.id}`, '_blank')
    }
  },
  beforeRouteEnter (to, from, next) {
    axios
      .get(
        'dhra/api/' +
          (to.params.api_version ? to.params.api_version : 'v2') +
          '/webiomedmpi/requests/' +
          to.params.id +
          '/'
      )
      .then(values => {
        axios.get('symptom-checker/api/groups-images-list/').then(response => {
          values.data.images = response.data
        })
        axios.get('symptom-checker/api/rules-groups-list/').then(response => {
          values.data.groups = response.data
          next(vm => vm.setData(values.data))
        })
      })
  }
}
</script>
<style lang="sass" scoped>
// @import "@/css/pageSummaryStyles.sass"
@import "@/css/pageSummaryStyles2.sass"

@media screen and (max-width: 1200px)
  #gridColumns5
    grid-template-columns: repeat(3, 1fr)
</style>
